class ReviewsPage {
  constructor() {
    this.el = document.querySelector('.ReviewsPage');
    this.tabList = this.el.querySelector('.ReviewsPageTablist');
    this.tabs = this.el.querySelectorAll('.ReviewsPageTablist__Tab');
    this.reviewsWidget = this.el.querySelector('.MatStampedReviews');
    this.widgetMetafields = this.reviewsWidget.querySelector('[data-first-pages-json]');

    this.attachListeners();
  }

  attachListeners() {
    this.tabList.addEventListener('click', e => {
      if (e.target.matches('.ReviewsPageTablist__Tab')) {
        const tab = e.target;

        // Set tab state
        this.tabs.forEach(t => t.setAttribute('aria-selected', 'false'));
        tab.setAttribute('aria-selected', 'true');

        // Set product in widget
        const productID = tab.dataset.tabProductId;
        const sku = tab.dataset.tabSku;
        this.reviewsWidget.dataset.productId = productID;
        this.reviewsWidget.dataset.sku = sku;

        // Set metafields
        const metafields = this.el.querySelector(`[data-tab-metafield-json="${productID}"]`);
        this.widgetMetafields.innerHTML = metafields.innerHTML;

        this.reviewsWidget.reinit();
      }
    });
  }
}

new ReviewsPage();
